/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'

import CPTable1 from './CPTable1'

const UsersorgMiansp: FC = () => <CPTable1 className='mb-5 mb-xl-8' />

export default UsersorgMiansp
